import axios from 'axios';

export const QueueApplicationsApi = {
  getApplications: (filter, search) => axios.get(
    `/api/public/info/order/kindergarten_voucher_queue?filter=${filter}&search=${search}`
  ),
};
